'use client';

import { GarminLogo } from '@/app/settings/VendorLogos';
import Loading from '@/app/components/Loading';
import { trpc } from '@/app/api/trpc/client';
import { useSearchParams } from 'next/navigation';

export const GarminConnectCard = () => {
  const { data: connected } = trpc.garmin.connected.useQuery();
  const searchParams = useSearchParams();
  const isConnecting = searchParams.get('garmin_connected') === 'true';

  const { mutate: connect, isPending: loadingOauthToken } =
    trpc.garmin.connect.useMutation({
      onSuccess: (authorizationUrl) => {
        if (!authorizationUrl) return;
        window.location.href = authorizationUrl;
      },
    });

  if (connected === true) {
    return (
      <div className='flex justify-start'>
        <button
          className='btn btn-info flex gap-2 items-center cursor-default opacity-80 h-10'
          disabled
        >
          <div className='w-12 h-6 flex items-center'>
            <GarminLogo />
          </div>
          <span className='font-medium'>Connected</span>
        </button>
      </div>
    );
  }

  return (
    <div className='flex justify-start'>
      {connected === false && !isConnecting ? (
        <button
          className='btn btn-primary py-1.5 px-3 flex items-center gap-2 text-sm shadow-sm h-10'
          onClick={() => connect({ origin: 'chat' })}
          disabled={loadingOauthToken}
        >
          <span className='text-nowrap text-white font-medium relative top-[2px]'>
            Connect with Garmin Connect
          </span>
          {loadingOauthToken && <Loading />}
        </button>
      ) : (
        <div className='flex items-center gap-2 p-2'>
          <Loading size={14} />
          <span className='text-xs text-gray-500'>
            {isConnecting ? 'Connecting Garmin...' : 'Checking...'}
          </span>
        </div>
      )}
    </div>
  );
};
